module.exports={render:function (){var _vm=this;
  return _vm._h('div', [_vm._h('div', {
    staticClass: "topbar"
  }, [_vm._h('div', {
    staticClass: "clearfix main-wrap"
  }, [_vm._h('a', {
    staticClass: "pull-left img-back",
    attrs: {
      "href": "javascript:window.history.go(-1)"
    }
  }, ["返回"]), " ", _vm._h('h1', [_vm._s(_vm.studentName) + "的作业"])]), " ", _vm._h('div', {
    staticClass: "liner"
  })]), " ", _vm._h('mt-loadmore', {
    ref: "loadmore",
    attrs: {
      "top-method": _vm.loadTop
    }
  }, [_vm._h('div', {
    directives: [{
      name: "infinite-scroll",
      rawName: "v-infinite-scroll",
      value: (_vm.loadBottom),
      expression: "loadBottom"
    }],
    staticClass: "main-page homework",
    attrs: {
      "infinite-scroll-disabled": "isGetting",
      "infinite-scroll-distance": "150"
    }
  }, [_vm._l((_vm.homeworkList), function(item) {
    return _vm._h('div', [_vm._h('div', {
      staticClass: "padding-15 teacher",
      class: {
        'teacher': item.clientType == 'teacher', parents: item.clientType == 'parents'
      }
    }, [_vm._h('div', {
      staticClass: "clearfix"
    }, [_vm._h('div', {
      staticClass: "header-pic"
    }, [_vm._h('a', {
      staticClass: "block"
    }, [_vm._h('span', {
      staticClass: "img-wrap small block"
    }, [_vm._h('img', {
      attrs: {
        "src": item.userImage ? _vm.baseAcessPath + item.userImage : _vm.img_default
      }
    })])])]), " ", _vm._h('div', {
      staticClass: "content"
    }, [_vm._h('span', {
      staticClass: "who"
    }, [_vm._s(item.userName + (item.clientType == 'teacher' ? '【 老师 】' : '')) + " -   " + _vm._s(_vm._f("dateDiff")(item.publishDate))]), " ", _vm._h('div', {
      staticClass: "wrap"
    }, [_vm._h('i'), " ", (item.field1 == '0') ? _vm._h('cite') : _vm._e(), " ", _vm._h('router-link', {
      attrs: {
        "to": {
          path: '/homework/detail/' + item.homeWorkId
        }
      }
    }, [_vm._s(item.content)])])])])])])
  }), " ", (_vm.homeworkList == 0) ? _vm._h('div', {
    staticClass: "text-center",
    staticStyle: {
      "padding-top": "200px"
    }
  }, ["暂无作业"]) : _vm._e()])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/.10.0.1@vue-loader/lib/template-compiler.js?id=data-v-1dac992c!./~/.10.0.1@vue-loader/lib/selector.js?type=template&index=0!./src/views/homework/homeworkStudent.vue
// module id = 184
// module chunks = 1